
import contentImg from "../assets/img/digitalMarketing/content1.jfif";
import paidMediaImg from "../assets/img/banner/pm.jpg";
import analyticsImg from "../assets/img/banner/a.jpg";
import { VscDebugBreakpointLog } from "react-icons/vsc";
import { Link } from "react-router-dom";
import { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
 import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../styles/banner.css"
import loader from "../assets/img/loader/loader1.jpg";
import LocalTimeWithLocation from "./NairobiTime";
import { TbNorthStar } from "react-icons/tb";
import { useParams } from "react-router-dom";
import { useMemo } from "react";
import Nav from "./Nav";
import { useMediaQuery } from "react-responsive";

const servicesData = [
  { 
    title: "Content & Creative", 
    description:
      "Attention spans are shrinking, and social media is more crowded than ever. Now’s the time for content and creative that truly stands out. We’ll make your prospects stop scrolling.",
    link: "/digital-marketing/services/content-creative",
    image: contentImg
  },
  { 
    title: "Paid Media & Performance", 
    description:
      "Every click should count. Our paid media strategies ensure your campaigns reach the right audience, at the right time, with the right message, so you see measurable results instead of wasted spend.",
    link: "/digital-marketing/services/paid-media-performance",
    image: paidMediaImg
  },
  { 
    title: "Analytics & Insights", 
    description:
      "Good decisions start with good data. We track, analyze, and turn your marketing metrics into clear insights, helping you make smarter moves and continuously improve your ROI.",
    link: "/digital-marketing/services/analytics-insights",
    image: analyticsImg
  }
];


export const Banner = () => {

   const serviceSlug = useMemo(() => {
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    return pathParts[pathParts.length - 1]; // "content-creative"
  }, []);

   const service = servicesData.find(s => s.link.endsWith(serviceSlug));

     const isDesktop = useMediaQuery({ minWidth: 768 });

  const description = useRef(null);
  const coverCenterRef = useRef(null);
  const yearRefs = [useRef(null), useRef(null)];
  const [isTextInView, setTextInView] = useState(false);
  const [areYearsInView, setYearsInView] = useState([false, false]);
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);
 


  
  const slideUp = {
    initial: {
      y: "100%",
    },
    open: (i) => ({
      y: "0%",
      transition: { duration: 0.5, delay: 0.01 * i },
    }),
    closed: {
      y: "100%",
      transition: { duration: 0.5 },
    },
  };

  useEffect(() => {
    const handleScroll = () => {
      const descriptionRect = description.current.getBoundingClientRect();
      setTextInView(descriptionRect.top < window.innerHeight / 1.15);

      setYearsInView(yearRefs.map(ref => ref.current.getBoundingClientRect().top < window.innerHeight / 1.15));
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };
  
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

 
  

  return (
    <>
    <Nav/>

      <section className="banner" id="home">
        <div className="service-category">
          <span>&apos; {service?.title} &apos;</span>
        </div>
        <div className="cover-header">
          <div className="year">
            <span className="mask">
              <motion.b
                variants={slideUp}
                custom={0}
                initial="initial"
                animate={areYearsInView[0] ? "open" : "closed"}
                ref={yearRefs[0]}
              >
                <TbNorthStar className="star-icon"/>
              </motion.b>
            </span>
            <span className="mask element-r">
              <motion.b
                variants={slideUp}
                custom={1}
                initial="initial"
                animate={areYearsInView[0] ? "open" : "closed"}
                ref={yearRefs[0]}
              >
               <TbNorthStar className="star-icon"/>
              </motion.b>
            </span>
          </div>
          <div className="cover-center" ref={coverCenterRef}>
           <h1>{service?.title.replace("&", "and")}</h1>
            
          </div>
          <div className="year">
            <span className="mask element-r">
              <motion.b
                variants={slideUp}
                custom={2}
                initial="initial"
                animate={areYearsInView[1] ? "open" : "closed"}
                ref={yearRefs[1]}
              >
               <TbNorthStar className="star-icon"/>
              </motion.b>
            </span>
            <span className="mask">
              <motion.b
                variants={slideUp}
                custom={3}
                initial="initial"
                animate={areYearsInView[1] ? "open" : "closed"}
                ref={yearRefs[1]}
              >
               <TbNorthStar className="star-icon"/>
              </motion.b>
            </span>
          </div>
        </div>
        <div className="banner-bottom">
          <div className="time-container">
        <LocalTimeWithLocation/>
          </div>
          
          <div className='name-wrapper'>
            <div className="name-container">
         
                    <LazyLoadImage
                      alt='Roarz'
                      title='Roarz Codes'
                      effect="blur"
                      src={service?.image || loader}
                      placeholderSrc={loader}
                      width={isDesktop ? "200px" : "100%"}
                      height="220px"
                      className="img-fluid mx-auto img-el"
                    />
             </div>
          </div>
          <div className="last-banner" ref={description}>
       
        <p>{service?.description}</p>
            <span> / / Scroll to Explore</span>
          </div>
        </div>
      </section>
    </>
  );
};
